/**
 * Interest rate type enum.
 */
export enum InterestRateTypeEnum {
  FIXED = 'Fixed',
  VARIABLE = 'Variable'
}
